export const getVocabularySoundList = lessonExam => {
    let list = []
    if (lessonExam.QuestionModel === null) return []
    lessonExam.QuestionModel.forEach(item => {
        list.push(item.VocabularyModel.AudioFileName)
    })
    return list
}
export const getAudioFileNameSoundList = todayList => {
    let list = []
    todayList.forEach(item => {
        list.push(item.AudioFileName)
    })
    return list
}



// WEBPACK FOOTER //
// ./src/plugin/getSoundList.js